export type ShareReportStatuses =
  (typeof ShareReportStatus)[keyof typeof ShareReportStatus]
export const ShareReportStatus = {
  Sent: 'SENT',
  Pending: 'PENDING',
  Failed: 'FAILED',
} as const
